export default __webpack_public_path__ + "static/media/certificate_napa_en.374fd17e.svg";